import Create from './create/CreateIncome';
import Edit from './edit/EditIncome';
import Individual from './individual/Income';

export default {Individual, Edit, Create}